import { render, staticRenderFns } from "./FlexSearch.vue?vue&type=template&id=7da4ea6e&"
import script from "./FlexSearch.vue?vue&type=script&lang=js&"
export * from "./FlexSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports